import { useMutation } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { expiredSelections } from '../utilities/SelectionDeadlineUtility';
import {
  saveConfigurationComplete, setConfigurationChanged, setPopupState, refreshSelectionDeadlines, setSnackbarMessage,
} from '../model/configuratorSlice';
import { AccessTokenAuth } from '../auth/AccessTokenAuth';
import { EndPoints, PopupState } from '../model/constants';
import { FeatureSelectionUtility } from '../utilities/FeatureSelectionUtility';


export default function SaveConfigurationService() {
  const {
    promotionSlug, currentUnit, categories, configurationChanged, isAdminPreview,
  } = useSelector(state => state.configurator);

  const dispatch = useDispatch();

  const onSuccessResponse = (onSuccessResponseCallback) => {
    dispatch(setConfigurationChanged(false));

    if (onSuccessResponseCallback !== undefined) {
      onSuccessResponseCallback();
    } else {
      dispatch(setPopupState(PopupState.SaveConfiguration));
      dispatch(saveConfigurationComplete());
    }
  };

  return useMutation(['saveConfigurationQuery'], (onSuccessCallback) => {
    if (isAdminPreview) return undefined;
    const expired = expiredSelections(categories);
    if (expired.length) {
      dispatch(refreshSelectionDeadlines(expired));
      dispatch(saveConfigurationComplete());
      return undefined;
    }
    const currentUnitCode = currentUnit !== null ? currentUnit.id : 0;
    const saveConfigurationUrl = `${EndPoints.SaveConfig}/${promotionSlug}/unit/${currentUnitCode}/configuration`;
    const featureSelection = FeatureSelectionUtility.CreateFeatureSelection(categories);
    const data = {
      feature_selection: featureSelection,
    };
    return axios
      .post(saveConfigurationUrl, data)
      .then((response) => {
        onSuccessResponse(onSuccessCallback);
      })
      .catch((error) => {
        dispatch(saveConfigurationComplete());
        if (error.response?.data?.code === 'selection_expired') {
          dispatch(refreshSelectionDeadlines(error.response.data.expired_selections));
        } else {
          dispatch(setSnackbarMessage('No se pudo guardar la configuración. Vuelve a intentarlo.'));
        }
      });
  });
}
